import { createFileRoute } from '@tanstack/react-router';
import { makeTableSearchValidator } from '../lib/table-filter.js';
import { ContactsPage } from './contacts.js';

export const Route = createFileRoute('/$workspaceSlug/contacts')({
  component: ContactsPage,
  validateSearch: makeTableSearchValidator({ view: 'uuid' }),
});
